import { Sidebar, Menu, MenuItem, SubMenu, menuClasses, MenuItemStyles } from 'react-pro-sidebar';
import { Link } from 'react-router-dom';

import React from 'react';

import { FaUser } from "react-icons/fa";
import { FaUserPlus } from "react-icons/fa6";
import { IoLogOut } from "react-icons/io5";
import { MdAccountTree } from "react-icons/md";
import { FaRunning } from "react-icons/fa";
import { FaHome } from "react-icons/fa";
import { FaFolderTree } from "react-icons/fa6"; 
import { SidebarHeader } from './z-components/SidebarHeader';
import { useDispatch, useSelector } from "react-redux";
import { logout } from "./actions/auth.js";
import ReactSwitch from 'react-switch';
import { Button } from 'react-bootstrap';
import { GiHamburger, GiHamburgerMenu } from "react-icons/gi";

/*
import { Switch } from './components/Switch';
import { SidebarHeader } from './components/SidebarHeader';
import { Diamond } from './icons/Diamond';
import { BarChart } from './icons/BarChart';
import { Global } from './icons/Global';
import { InkBottle } from './icons/InkBottle';
import { Book } from './icons/Book';
import { Calendar } from './icons/Calendar';
import { ShoppingCart } from './icons/ShoppingCart';
import { Service } from './icons/Service';
import { SidebarFooter } from './components/SidebarFooter';
import { Badge } from './components/Badge';
import { Typography } from './components/Typography';
import { PackageBadges } from './components/PackageBadges';
*/


const themes = {
    light: {
        sidebar: {
            backgroundColor: '#ffffff',
            color: '#607489',
        },
        menu: {
            menuContent: '#fbfcfd',
            icon: '#0098e5',
            hover: {
                backgroundColor: '#c5e4ff',
                color: '#44596e',
            },
            disabled: {
                color: '#9fb6cf',
            },
        },
    },
    dark: {
        sidebar: {
            backgroundColor: '#0b2948',
            color: '#fff',
        },
        menu: {
            menuContent: '#082440',
            icon: '#59d0ff',
            hover: {
                backgroundColor: '#00458b',
                color: '#b6c8d9',
            },
            disabled: {
                color: '#3e5e7e',
            },
        },
    },
};

// hex to rgba converter
const hexToRgba = (hex, alpha) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};    

const ExportSidebar = () => {
    const [collapsed, setCollapsed] = React.useState(false);
    const [toggled, setToggled] = React.useState(false);
    const [broken, setBroken] = React.useState(false);
    const [rtl, setRtl] = React.useState(false);
    const [hasImage, setHasImage] = React.useState(false);
    const [theme, setTheme] = React.useState('dark');        

    const dispatch = useDispatch();
    
    const handleLogout = () => {
        //e.preventDefault();		
        
        dispatch(logout())
        .then(() => {
            //props.history.push("/");
            window.location.reload();
        })
        .catch((e) => {
            console.log(e);
        });
    };     
  
    // handle on RTL change event
    const handleRTLChange = (e) => {
        setRtl(e.target.checked);
    };
  
    // handle on theme change event
    const handleThemeChange = (e) => {
        setTheme(e.target.checked ? 'dark' : 'light');
    };
  
    // handle on image change event
    const handleImageChange = (e) => {
        setHasImage(e.target.checked);
    }; 
    
    const handleCollapsed = () => {
        setCollapsed(!collapsed);
    }
  
    const handleToggled = () => {
        setToggled(!toggled);
    }

    const menuItemStyles = {
        root: {
            fontSize: '13px',
            fontWeight: 400,
        },
        icon: {
            color: themes[theme].menu.icon,
            [`&.${menuClasses.disabled}`]: {
            color: themes[theme].menu.disabled.color,
            },
        },
        SubMenuExpandIcon: {
            color: '#b6b7b9',
        },
        subMenuContent: ({ level }) => ({
            backgroundColor:
            level === 0
                ? hexToRgba(themes[theme].menu.menuContent, hasImage && !collapsed ? 0.4 : 1)
                : 'transparent',
        }),
        button: {
            [`&.${menuClasses.disabled}`]: {
            color: themes[theme].menu.disabled.color,
            },
            '&:hover': {
            backgroundColor: hexToRgba(themes[theme].menu.hover.backgroundColor, hasImage ? 0.8 : 1),
            color: themes[theme].menu.hover.color,
            },
        },
        label: ({ open }) => ({
            fontWeight: open ? 600 : undefined,
        }),
    };


  
    return (
        <>
            {broken &&
                <Button variant='secondary' onClick={handleToggled} style={{position:'fixed',padding:'10px'}}><GiHamburgerMenu /></Button>
            }
        <div style={{ display: 'flex', height: '100%', direction: rtl ? 'rtl' : 'ltr', }}>
            <Sidebar
                collapsed={collapsed}
                toggled={toggled}
                onBackdropClick={() => setToggled(false)}
                onBreakPoint={setBroken}
                image="https://user-images.githubusercontent.com/25878302/144499035-2911184c-76d3-4611-86e7-bc4e8ff84ff5.jpg"
                rtl={rtl}
                breakPoint="md"
                backgroundColor={hexToRgba(themes[theme].sidebar.backgroundColor, hasImage ? 0.9 : 1)}
                rootStyles={{
                    color: themes[theme].sidebar.color,
                }}            
            >
                <SidebarHeader rtl={rtl} style={{ marginBottom: '24px', marginTop: '16px' }} />
            <hr />
            <Menu
                menuItemStyles={menuItemStyles}
            >
                {/**
                <SubMenu
                    label="Charts"
                    icon={<FaUser />}
                >
                    <MenuItem component={<Link to="/documentation" />}> Usuarios</MenuItem>        
                </SubMenu>            
                */}
                <MenuItem icon={<FaHome />} component={<Link to="/dashboard" />}>Inicio</MenuItem>
                <MenuItem icon={<FaUser />} component={<Link to="/admin-users" />}>Usuarios</MenuItem>            
                <MenuItem icon={<FaFolderTree />} component={<Link to="/areas" />}>Areas</MenuItem>              
                <MenuItem icon={<FaRunning />} component={<Link to="/competencias" />}>Competencias</MenuItem>
                <MenuItem icon={<MdAccountTree />} component={<Link to="/organigramas" />}>Organigramas</MenuItem>
                <hr />
                <MenuItem icon={<IoLogOut />} onClick={handleLogout}>Salir</MenuItem>
            </Menu>
            </Sidebar>
        </div>
</>

    );
}

export default ExportSidebar;